<template>
  <div class="npa-link-list" v-if="npas.length > 0">
    <div class="npa-link-item" v-for="npa in npas" :key="npa.id">
      <router-link
        tag="a"
        :title="npa.transProjectGoal | strippedContent"
        :to="$i18nRoute({ name: 'view-npa', params: { id: npa.id } })"
        :key="npa.id"
      >
        {{ npa.transName | splitTextIntoLines(2, 40) }}
      </router-link>
      <div class="npa-link-list-developer">
        {{ $t('Разработчик') }}:
        <v-icon
          v-if="npa.developerStatus === false"
          class="nv_icon mr-1"
          x-small
        />
        {{ npa.developerTransName }}
      </div>
      <div>
        {{ $t('Дата публикации') }}: <span class="date">{{ new Date(npa.publishDate) | dateFormat('DD.MM.YYYY') }}</span>
      </div>
    </div>
    <template v-if="otherNpas.length > 0">
      <p class="btn-other"><a href="#" @click.prevent="otherShow = !otherShow">{{ otherShow === true ? $t('Скрыть остальные') : $t('Показать все') }}</a></p>
      <div class="other" v-show="otherShow">
        <div class="npa-link-item" v-for="npa in otherNpas" :key="npa.id">
          <router-link
            tag="a"
            :title="npa.transProjectGoal | strippedContent"
            :to="$i18nRoute({ name: 'view-npa', params: { id: npa.id } })"
            :key="npa.id"
          >
            {{ npa.transName | splitTextIntoLines(2, 40) }}
          </router-link>
          <div class="npa-link-list-developer">
            {{ $t('Разработчик') }}:
            <v-icon
              v-if="npa.developerStatus === false"
              class="nv_icon mr-1"
              x-small
            />
            {{ npa.developerTransName }}
          </div>
          <div>
            {{ $t('Дата публикации') }}: <span class="date">{{ new Date(npa.publishDate) | dateFormat('DD.MM.YYYY') }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
  <div class="npa-link-list" v-else>
    <p>{{ $t('У Вас нет просмотренных проектов') }}</p>
  </div>
</template>

<script>
import CMS from '@/model/cms'

export default {
  props: {
    widget: Object
  },
  data: () => ({
    npas: [],
    otherNpas: [],
    otherShow: false
  }),
  mounted() {
    const userNpaIds = JSON.parse(localStorage.getItem("userNpaIds") || '[]')
    userNpaIds.sort(function (a, b) {
      if (a.datetime < b.datetime) {
        return 1;
      }
      if (a.datetime > b.datetime) {
        return -1;
      }
      return 0;
    })
    const npaIds = []
    userNpaIds.forEach((element, key) => {
      npaIds.push(element.id)
    })
    CMS.getViewedNpasByIds({userNpaIds: npaIds})
      .then((response) => {
        this.npas = response.data.npas
        this.otherNpas = response.data.otherNpas
      })
      .catch((error) => {
        //@todo ошибки
      })
  }
}
</script>
<style>
  .btn-other {
    text-align: right;
  }
</style>
